/**
 * ============================================================================
 * TRANSIENT: Appointment Config Page (appointment-config-page)
 * Type: poc
 * Amplitude key: none
 * End date: 2026-12-31
 * PR: #TODO_AFTER_PR_CREATION_appointment-config-page
 * ============================================================================
 */

import { useState } from 'react';

import { Box, Button, Chip, Stack, Typography } from '@evaneos/b2b-ui';
import CircleIcon from '@evaneos/b2b-ui/icons/Circle';
import { useIntl } from 'react-intl';

import { AppointmentDisconnectConfirmDialog } from '../../../pages/Appointment/components/AppointmentDisconnectConfirmDialog';
import { useDisconnectCalendarMutation } from '../../../resources/appointment/mutations';

export const AppointmentGoogleConnectionPartial = (): JSX.Element => {
    const { formatMessage } = useIntl();
    const { mutate: disconnect, isPending } = useDisconnectCalendarMutation();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleConfirm = () => {
        disconnect('google');
        setIsDialogOpen(false);
    };

    return (
        <Stack data-spec-id="agenda-section-google-connection" spacing={3}>
            <Box>
                <Typography variant="h3" sx={{ fontWeight: 700, fontSize: 20, mb: 0.5 }}>
                    {formatMessage({ id: 'appointment.google_connection.title' })}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {formatMessage({ id: 'appointment.google_connection.description' })}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Chip
                    data-spec-id="agenda-google-connected-status"
                    icon={
                        <CircleIcon sx={{ fontSize: '10px !important', color: 'success.main' }} />
                    }
                    label={formatMessage({ id: 'appointment.google_connection.connected_status' })}
                    variant="outlined"
                    size="small"
                />
                <Button
                    data-spec-id="agenda-google-disconnect-btn"
                    variant="outlined"
                    color="error"
                    size="small"
                    disabled={isPending}
                    onClick={() => setIsDialogOpen(true)}
                >
                    {isPending
                        ? formatMessage({ id: 'appointment.google_connection.disconnecting' })
                        : formatMessage({ id: 'appointment.google_connection.disconnect_button' })}
                </Button>
            </Box>

            <AppointmentDisconnectConfirmDialog
                isOpen={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                onConfirm={handleConfirm}
            />
        </Stack>
    );
};
